import {jwtDecode } from 'jwt-decode';
import { login } from "../../../helpers/fakebackend_helper";
import { loginSuccess, apiError, reset_login_flag } from './reducer';
import { redirect } from 'react-router-dom';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const loginUser = (user, history) => async (dispatch) => {
  try {    
    var data = await login(user);
    if (data.token) {
      const token = jwtDecode(data.token);
      sessionStorage.setItem("authUser", JSON.stringify({...data, ...token}));
      toast.success("Prijava uspješna!", { autoClose: 3000 });
      history("/dashboard");      
      dispatch(loginSuccess(data));      
    } 
    else {
      toast.error("Prijava neuspješna! Pokušajte ponovno!.", { autoClose: 3000 });
      dispatch(apiError(data));
    }    
  } catch (error) {
    dispatch(apiError(error));
    toast.error("Greška! Provjerite unesene kredencijale!", { autoClose: 3000 });
  }
};

export const logoutUser = () => async (dispatch) => {
  try {    
    sessionStorage.clear();
    redirect('/login');
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch) =>{
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};